import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import RecentlyViewedContainer from 'Containers/RecentlyViewed/RecentlyViewedContainer';
import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';

const messages = defineMessages({
  title: {
    id: 'recentlyviewedpage.title',
    defaultMessage: 'Recently Viewed | PC and Steam Games | Fanatical',
  },
});

/**
 * dedicated page to display the last 36 viewed products across the site
 * @param {Object} intl contains format message for translations
 */
const RecentlyViewedPage = ({ intl }) => {
  const { formatMessage } = intl;
  return (
    <div className="container">
      <Meta title={formatMessage(messages.title)} url="recently-viewed" />
      <NoIndex />
      <div className="pb-5 pt-5">
        <h1 className="pb-3">
          <FormattedMessage id="recentlyviewedpage.header" defaultMessage="Recently Viewed" />
        </h1>
        <RecentlyViewedContainer hitsToDisplay={36} />
      </div>
    </div>
  );
};

export default RecentlyViewedPage;
